import { render, staticRenderFns } from "./CreateProductOrderShipmentPopUp.vue?vue&type=template&id=4b0d650b&scoped=true&"
import script from "./CreateProductOrderShipmentPopUp.vue?vue&type=script&lang=js&"
export * from "./CreateProductOrderShipmentPopUp.vue?vue&type=script&lang=js&"
import style0 from "./CreateProductOrderShipmentPopUp.vue?vue&type=style&index=0&id=4b0d650b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0d650b",
  null
  
)

export default component.exports